import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { Subject, takeUntil } from 'rxjs';
import { ConfigDataService } from 'src/app/services/config-data.service';
import { UserService } from 'src/app/services/user.service';
import { CONFIGURATION_UPDATE, CONFIGURATION_ALL, RISK_ANALYTICS_ACCESS_TYPE, DILIGENT_SCREENING_VENDOR } from '../../constants';

@Component({
  selector: 'app-view-configuration',
  templateUrl: './view-configuration.component.html',
  styleUrls: ['./view-configuration.component.scss'],
  providers: [ConfirmationService]
})
export class ViewConfigurationComponent implements OnInit, OnDestroy {
  private unsubscribe$ = new Subject<void>();
  accountId: string = '';
  enrollmentId: string = '';
  configId: string = '';
  accountName = '';
  configData!: GetConfigurationResponse;
  public watchList_sanc = {} as ScreeningLevel;
  public watchLists = {} as ScreeningLevel;
  public sanctions = {} as ScreeningLevel;
  public political = {} as ScreeningLevel;
  public adverseMedia = {} as ScreeningLevel;
  public diligentSOE = {} as ScreeningLevel;
  public diligentWatchlist = {} as ScreeningLevel;
  public diligentSanctions = {} as ScreeningLevel;
  public customListEnabled = "";
  public is_WLS_Enable = false;
  public createDataset  = false;
  public selectedFileName = "";

  ifUser: boolean = false;
  items: MenuItem[] = [
    { label: 'Account Details', routerLink: '/config/account/list' },
    { label: 'View Configuration Details' }];
  showAudit = false;
  filterObject = {
    type: "Configuration",
    id: ""
  };
  editConfigPermissions = [CONFIGURATION_UPDATE, CONFIGURATION_ALL];
  public allowEmails = ['panchala@dnb.com', 'londheh@dnb.com', 'ballonet@dnb.com'];
  public selectedDatasetId = "";
  public receivedJson: any; // Property to store the received JSON data
  public displayDataset = false;
  public sourceList_watch_sanc:any = [];
  public sourceList_watch:any = [];
  public sourceList_sanc:any = [];
  public displayAddSourceModal = false;
  public sourceIdToAdd = '';
  public sourceToAdd_customListId = '';
  public sourceToAdd_product = '';
  public isRaAccount = false;
  public isDiligent = false;

  constructor(
    private route: ActivatedRoute,
    private configService: ConfigDataService,
    private messageService: MessageService,
    private userService: UserService,
    private confirmationService: ConfirmationService
  ) { }

  ngOnInit(): void {
    this.userService.getCurrentUser().subscribe(user => {
      if (this.allowEmails.indexOf(user.emailAddress) > -1) {
          this.ifUser = true;
      }
    });
    this.configService.enable_WLS_SPLIT.subscribe(val =>{this.is_WLS_Enable = val;});
    this.route.params
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(params => {
        this.getConfigurationById(params['accountId'], params['configId']); 
      });
  }

  getConfigurationById(accountId: string, configId: string) {
    this.accountId = accountId;
    this.configId = configId;
    this.configService.getConfigurationsById(accountId, configId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((result) => {
        if (result?.responseData) {
          this.configData = result.responseData.configurationResponse;
          this.enrollmentId = this.configData.enrollmentId || '';
          this.filterObject.id = this.configId;
          this.configData.screeningLevels.map((screeningLevel: ScreeningLevel) => {
            switch (screeningLevel.code) {
              case '1':
                this.watchList_sanc = screeningLevel;
                 if(this.watchList_sanc.customListOptions?.customListEnabled) {
                  this.getCustomListSource(this.watchList_sanc.customListId || "", "watchList_sanc");
                }
                break;
              case '2':
                this.political = screeningLevel;
                break;
              case '3':
                this.adverseMedia = screeningLevel;
                break;
              case '4':
                this.watchLists = screeningLevel;
                 if(this.watchLists.customListOptions?.customListEnabled) {
                  this.getCustomListSource(this.watchLists.customListId || "", "watchLists");
                }
                break;
              case '5':
                this.sanctions = screeningLevel;
                if(this.sanctions.customListOptions?.customListEnabled) {
                  this.getCustomListSource(this.sanctions.customListId || "", "sanctions");
                }
              break;
              case '6':
                this.diligentSOE = screeningLevel;
              break;
            }
          });
          this.customListEnabled = this.watchList_sanc?.customListOptions?.customListEnabled ? "Yes" : "No";
          // RA specific view 
          this.isRaAccount = this.configData.accessType === RISK_ANALYTICS_ACCESS_TYPE;
          this.is_WLS_Enable = this.isRaAccount;
          this.isDiligent = this.configData.screeningVendor === DILIGENT_SCREENING_VENDOR;
        }
      });
  }

  getCustomListSource(listId: string, product: string) {
    if(listId !== "")
    this.configService.listCustomListSource(listId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((result:any) => {
        if (result) 
        {
          switch (product) {
            case "watchList_sanc":
              this.sourceList_watch_sanc = result.responseData.customListDetails;
            break;
            case "watchLists":
              this.sourceList_watch = result.responseData.customListDetails;
            break;
            case "sanctions":
              this.sourceList_sanc = result.responseData.customListDetails;
            break;
          }
        }
      }); 
  }

  showAddSourceModal(product: string, customListId: string) {
    this.sourceToAdd_product = product;
    this.sourceToAdd_customListId = customListId;
    this.sourceIdToAdd = ''; // Reset input
    this.displayAddSourceModal = true;
  }

  public exportSourceListAsCsv(data: any[], fileName: string) {
    if (!data || data.length === 0) {
      this.messageService.add({ severity: 'info', summary: 'Info', detail: 'There is no data to export.' });
      return;
    }

    // Define headers and corresponding data fields
    const headers = ['ID', 'Source Id', 'Name', 'Agency'];
    const fields = ['customListSourceId', 'sourceId', 'sourceName', 'sourceAgency'];

    // Convert array of JSON objects to CSV string
    const replacer = (key: any, value: any) => value === null ? '' : value;
    let csv = data.map(row => fields.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
    csv.unshift(headers.join(','));
    const csvArray = csv.join('\r\n');

    this.downLoadFile(csvArray, fileName);
  } 

  downLoadFile(data: any, lable: string) {
    let date = new Date();
    let timeStamp = date.getFullYear() + ('0' + (date.getMonth() + 1)).slice(-2) + ('0' + date.getDate()).slice(-2) + ('0' + date.getHours() ).slice(-2) + ('0' + date.getMinutes()).slice(-2) + ('0' + date.getSeconds()).slice(-2) 
    let blob = new Blob([data], { type: 'text/csv' });
    let url = window.URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = url;
    link.download =  lable;
    link.click();
  }

  public changed(evt: any) {    
    this.configService.enable_WLS_SPLIT.next(evt.target.checked);
    }
  
    removeSource(sourceId: string, customListId: string, product: string) {
      this.confirmationService.confirm({
        message: 'Are you sure you want to remove this source?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.configService.removeCustomListSource(sourceId, customListId)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(() => {
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Source removed successfully' });
              // Refresh your source list data after removal
              this.getCustomListSource(customListId, product);
            }, () => {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to remove source' });
            });
        }
      });
    }

  submitAddSource() {
    if (!this.sourceIdToAdd || !this.sourceToAdd_customListId) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Source ID is required.' });
      return;
    }
    this.configService.addSourceToCustomList(this.sourceIdToAdd, this.sourceToAdd_customListId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Source added successfully' });
        this.getCustomListSource(this.sourceToAdd_customListId, this.sourceToAdd_product);
        this.displayAddSourceModal = false;
      }, () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to add source' });
      });
  }

  // Method to handle the event emitted by the child
  handleJson(eventData: any) {
    this.receivedJson = JSON.parse(eventData); // Store the data in a local property
    if(this.receivedJson.dataSetId) {
      this.displayDataset = true;
      this.selectedDatasetId = this.receivedJson.dataSetId;
    } else if(this.receivedJson.fileName) {
      this.createDataset = true;
      this.selectedFileName = this.receivedJson.fileName;
    }
  }
    

  public ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
